import { Link } from "react-router-dom";
import { ImageMonitorHost } from "../../Atoms/ClipArt/ClipArt";
import { Button } from "antd";
import { IconClose } from "../../Atoms/FontIcons/FontIcons";
import { themeVariables } from "../../../../styles/styled-components/StyledComponentThemesVariables";
import {
  StyledTable,
  StyledRow,
  StyledDiv,
  LastCheck,
  TableDivider,
  Centered,
  CenteredTable,
  StatusCircle
} from "../../Atoms/MonitorCard/MonitorCard";

const MonitorHosts = (props) => {
  const handleButton = () => alert("You clicked the 'Clear Unhandled' button");
  const Monitoring = () =>
    props.data && (
      <>
        <CenteredTable>
          <StyledTable>
            <tbody>
              <StyledRow>
                <td>
                  <StatusCircle style={{
                    backgroundColor: themeVariables.colorOk,
                    borderColor: themeVariables.colorOk
                  }} />
                </td>
                <td>Up</td>
                <td>{props.data.up}</td>
                <td>
                  <Button type="link">
                    <Link to="/status/hosts/up">
                      View
                    </Link>
                  </Button>
                </td>
              </StyledRow>
              <StyledRow>
                <td>
                  <StatusCircle style={{
                    backgroundColor: themeVariables.colorCritical,
                    borderColor: themeVariables.colorCritical
                  }} />
                </td>
                <td>Down</td>
                <td>{props.data.down}</td>
                <td>
                  <Button type="link">
                    <Link to="/status/hosts/down">
                      View
                    </Link>
                  </Button>
                </td>
              </StyledRow>
              <StyledRow>
                <td><StatusCircle /></td>
                <td>Unreachable</td>
                <td>{props.data.unreachable}</td>
                <td>
                  <Button type="link">
                    <Link to="/status/hosts/unreachable">
                      View
                    </Link>
                  </Button>
                </td>
              </StyledRow>
              <StyledRow>
                <td><StatusCircle /></td>
                <td>Pending</td>
                <td>{props.data.pending}</td>
                <td>
                  <Button type="link">
                    <Link to="/status/hosts/pending">
                      View
                    </Link>
                  </Button>
                </td>
              </StyledRow>
              <StyledRow>
                <td><StatusCircle /></td>
                <td>All</td>
                <td>{props.data.all}</td>
                <td>
                  <Button type="link">
                    <Link to="/status/hosts">
                      View
                    </Link>
                  </Button>
                </td>
              </StyledRow>
            </tbody>
          </StyledTable>
          <TableDivider />
          <StyledTable>
            <tbody>
              <StyledRow>
                <td>
                  <StatusCircle style={{
                    backgroundColor: themeVariables.colorUnhandled,
                    borderColor: themeVariables.colorUnhandled
                  }} />
                </td>
                <td>Unhandled</td>
                <td>{props.data.unhandled}</td>
                <td>
                  <Button type="link">
                    <Link to="/status/hosts/unhandled">
                      View
                    </Link>
                  </Button>
                </td>
              </StyledRow>
              <StyledRow>
                <td>
                  <StatusCircle style={{
                    backgroundColor: themeVariables.colorProblems,
                    borderColor: themeVariables.colorProblems
                  }} />
                </td>
                <td>Problems</td>
                <td>{props.data.problems}</td>
                <td>
                  <Button type="link">
                    <Link to="/status/hosts/problems">
                      View
                    </Link>
                  </Button>
                </td>
              </StyledRow>
            </tbody>
          </StyledTable>
        </CenteredTable>
        {props.data.unhandled ?
          <StyledDiv>
            <Button block onClick={handleButton}>
              <IconClose /> Clear Unhandled
            </Button>
          </StyledDiv>
         : <LastCheck />}
        {props.data.last_updated && (
          <LastCheck>Last check: {props.data.last_updated}</LastCheck>
        )}
      </>
    );

  const NotMonitoring = () => (
    <Centered>
      <ImageMonitorHost />
      <h3>You aren't monitoring any hosts yet!</h3>
      <p>Once you've setup a host, you will see data here.</p>
      <a href="/">See Setup Wizards</a>
    </Centered>
  );

  return props.isMonitoring ? <Monitoring /> : <NotMonitoring />;
};

export default MonitorHosts;
